import { Pagination } from 'react-admin'

Pagination.defaultProps = {
  ...Pagination.defaultProps,
  rowsPerPageOptions: [25, 50, 75, 100],
  rowsPerPage: 25,
}
